import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=b6a5cee8&"
import script from "./Request.vue?vue&type=script&lang=js&"
export * from "./Request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports